import { render } from "./donation_campaign_dashboard.html?vue&type=template&id=625a8bda&external"
import script from "./donation_campaign_dashboard.js?vue&type=script&lang=js&external"
export * from "./donation_campaign_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__